<template>
    <div>
        <div class="card-header">
            <div class="card-title">{{ $t('iclass_report') }}</div>
        </div>
        <div class="card-body">
            <div class="navigator"
                style="position: relative; display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
                <button class="btn-left" @click="prevReport" v-if="!loading && !hasOneReport"
                    :disabled="reportIndex <= 0">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9 17.125C7.39303 17.125 5.82214 16.6485 4.486 15.7557C3.14985 14.8629 2.10844 13.594 1.49348 12.1093C0.87852 10.6247 0.717618 8.99099 1.03112 7.41489C1.34463 5.83879 2.11846 4.39106 3.25476 3.25476C4.39106 2.11846 5.8388 1.34463 7.41489 1.03112C8.99099 0.717614 10.6247 0.878516 12.1093 1.49348C13.594 2.10844 14.8629 3.14984 15.7557 4.48599C16.6485 5.82214 17.125 7.39302 17.125 9C17.1225 11.1541 16.2657 13.2193 14.7425 14.7425C13.2193 16.2657 11.1541 17.1225 9 17.125ZM10.6681 6.65198C10.7291 6.59709 10.7788 6.5307 10.8141 6.45663C10.8495 6.38255 10.87 6.30223 10.8743 6.22025C10.8786 6.13827 10.8668 6.05624 10.8394 5.97885C10.812 5.90146 10.7696 5.83022 10.7147 5.7692C10.6598 5.70819 10.5934 5.65859 10.5193 5.62325C10.4452 5.5879 10.3649 5.56751 10.2829 5.56322C10.2009 5.55893 10.1189 5.57083 10.0415 5.59825C9.96412 5.62567 9.8929 5.66807 9.83191 5.72302L6.70691 8.53552C6.64179 8.59411 6.58972 8.66574 6.55407 8.74576C6.51842 8.82578 6.5 8.9124 6.5 9C6.5 9.0876 6.51842 9.17422 6.55407 9.25424C6.58972 9.33426 6.64179 9.40589 6.70691 9.46448L9.83191 12.277C9.8929 12.3319 9.96412 12.3743 10.0415 12.4017C10.1189 12.4292 10.2009 12.4411 10.2829 12.4368C10.3649 12.4325 10.4452 12.4121 10.5193 12.3768C10.5934 12.3414 10.6598 12.2918 10.7147 12.2308C10.7696 12.1698 10.812 12.0985 10.8394 12.0211C10.8668 11.9438 10.8786 11.8617 10.8743 11.7798C10.87 11.6978 10.8495 11.6174 10.8141 11.5434C10.7788 11.4693 10.7291 11.4029 10.6681 11.348L8.05945 9L10.6681 6.65198Z"
                            fill="white" />
                    </svg>
                    {{ $t('btn_pre_report') }}
                </button>
                <div style="text-align: center; flex: 1;">
                    <input class="hidden" id="calendar" v-model="currentDateOnCalendar" />
                    <button class="btn-date" v-if="!loading" @click="showCalendar">
                        {{ reportDateFormat }} <svg class="ms-1 mb-1" width="25" height="25" viewBox="0 0 20 20"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16.2495 2.49976H14.3745V1.87476C14.3745 1.709 14.3087 1.55002 14.1915 1.43281C14.0742 1.3156 13.9153 1.24976 13.7495 1.24976C13.5838 1.24976 13.4248 1.3156 13.3076 1.43281C13.1904 1.55002 13.1245 1.709 13.1245 1.87476V2.49976H6.87451V1.87476C6.87451 1.709 6.80866 1.55002 6.69145 1.43281C6.57424 1.3156 6.41527 1.24976 6.24951 1.24976C6.08375 1.24976 5.92478 1.3156 5.80757 1.43281C5.69036 1.55002 5.62451 1.709 5.62451 1.87476V2.49976H3.74951C3.41809 2.50008 3.10034 2.63188 2.86599 2.86623C2.63164 3.10058 2.49984 3.41834 2.49951 3.74976V16.2498C2.49984 16.5812 2.63164 16.8989 2.86599 17.1333C3.10034 17.3676 3.41809 17.4994 3.74951 17.4998H16.2495C16.5809 17.4994 16.8987 17.3676 17.133 17.1333C17.3674 16.8989 17.4992 16.5812 17.4995 16.2498V3.74976C17.4992 3.41834 17.3674 3.10058 17.133 2.86623C16.8987 2.63188 16.5809 2.50008 16.2495 2.49976ZM16.2495 6.24976H3.74951V3.74976H5.62451V4.37476C5.62451 4.54052 5.69036 4.69949 5.80757 4.8167C5.92478 4.93391 6.08375 4.99976 6.24951 4.99976C6.41527 4.99976 6.57424 4.93391 6.69145 4.8167C6.80866 4.69949 6.87451 4.54052 6.87451 4.37476V3.74976H13.1245V4.37476C13.1245 4.54052 13.1904 4.69949 13.3076 4.8167C13.4248 4.93391 13.5838 4.99976 13.7495 4.99976C13.9153 4.99976 14.0742 4.93391 14.1915 4.8167C14.3087 4.69949 14.3745 4.54052 14.3745 4.37476V3.74976H16.2495V6.24976Z"
                                fill="#3263C0" />
                        </svg>
                    </button>
                    <h2 style="color: #000; text-align: center; font-size:20px" v-if="!loading">iClass:
                        <b>{{
                            className }}</b>
                    </h2>
                </div>
                <button class="btn-right" @click="nextReport" v-if="!loading && !hasOneReport"
                    :disabled="!reportDateSplit[currentDate] || reportIndex >= reportDateSplit[currentDate].length - 1">
                    {{ $t('btn_next_report') }}
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9 17.125C10.607 17.125 12.1779 16.6485 13.514 15.7557C14.8502 14.8629 15.8916 13.594 16.5065 12.1093C17.1215 10.6247 17.2824 8.99099 16.9689 7.41489C16.6554 5.83879 15.8815 4.39106 14.7452 3.25476C13.6089 2.11846 12.1612 1.34463 10.5851 1.03112C9.00901 0.717614 7.37534 0.878516 5.8907 1.49348C4.40605 2.10844 3.13709 3.14984 2.24431 4.48599C1.35152 5.82214 0.874997 7.39302 0.874997 9C0.877486 11.1541 1.73431 13.2193 3.2575 14.7425C4.7807 16.2657 6.84588 17.1225 9 17.125ZM7.33191 6.65198C7.27086 6.59709 7.22124 6.5307 7.18586 6.45663C7.15048 6.38255 7.13004 6.30223 7.12571 6.22025C7.12138 6.13827 7.13324 6.05624 7.16063 5.97885C7.18801 5.90146 7.23037 5.83022 7.28529 5.7692C7.34021 5.70819 7.40662 5.65859 7.48071 5.62325C7.55481 5.5879 7.63514 5.56751 7.71712 5.56322C7.7991 5.55893 7.88113 5.57083 7.9585 5.59825C8.03588 5.62567 8.1071 5.66807 8.16809 5.72302L11.2931 8.53552C11.3582 8.59411 11.4103 8.66574 11.4459 8.74576C11.4816 8.82578 11.5 8.9124 11.5 9C11.5 9.0876 11.4816 9.17422 11.4459 9.25424C11.4103 9.33426 11.3582 9.40589 11.2931 9.46448L8.16809 12.277C8.1071 12.3319 8.03588 12.3743 7.9585 12.4017C7.88112 12.4292 7.7991 12.4411 7.71712 12.4368C7.63514 12.4325 7.55481 12.4121 7.48071 12.3768C7.40662 12.3414 7.34021 12.2918 7.28529 12.2308C7.23037 12.1698 7.18801 12.0985 7.16063 12.0211C7.13324 11.9438 7.12138 11.8617 7.12571 11.7798C7.13004 11.6978 7.15048 11.6174 7.18586 11.5434C7.22124 11.4693 7.27086 11.4029 7.33191 11.348L9.94055 9L7.33191 6.65198Z"
                            fill="white" />
                    </svg>
                </button>
            </div>

            <div>
                <div class="sessions-wrapper no-scroll">
                    <button class="sessions-nav ghost left" @click="slide(-1)" :disabled="!canScrollLeft"
                        aria-label="Scroll left">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13 26C15.5712 26 18.0846 25.2376 20.2224 23.8091C22.3602 22.3806 24.0265 20.3503 25.0104 17.9749C25.9944 15.5994 26.2518 12.9856 25.7502 10.4638C25.2486 7.94207 24.0105 5.62569 22.1924 3.80761C20.3743 1.98953 18.0579 0.751401 15.5362 0.249793C13.0144 -0.251815 10.4005 0.00562804 8.02511 0.989568C5.64967 1.97351 3.61935 3.63975 2.19089 5.77759C0.762429 7.91543 -7.08332e-06 10.4288 -6.85854e-06 13C0.00397789 16.4466 1.3749 19.7509 3.81201 22.188C6.24911 24.6251 9.5534 25.996 13 26ZM8.83105 12.2568L13.831 7.75684C13.9286 7.66891 14.0426 7.60108 14.1664 7.55721C14.2902 7.51334 14.4214 7.49429 14.5526 7.50115C14.6838 7.50801 14.8123 7.54065 14.9308 7.5972C15.0494 7.65375 15.1556 7.7331 15.2435 7.83073C15.3314 7.92835 15.3992 8.04233 15.443 8.16616C15.4868 8.28999 15.5058 8.42123 15.4989 8.5524C15.4919 8.68356 15.4592 8.81208 15.4026 8.9306C15.346 9.04913 15.2666 9.15534 15.1689 9.24317L10.9951 13L15.1689 16.7568C15.3659 16.9343 15.4843 17.1827 15.4982 17.4474C15.512 17.7122 15.4202 17.9716 15.2428 18.1686C15.0654 18.3657 14.8171 18.4842 14.5524 18.4982C14.2876 18.5122 14.0282 18.4204 13.831 18.2432L8.83105 13.7432C8.72685 13.6494 8.64353 13.5348 8.5865 13.4068C8.52947 13.2788 8.49999 13.1402 8.49999 13C8.49999 12.8598 8.52947 12.7213 8.5865 12.5932C8.64353 12.4652 8.72685 12.3506 8.83105 12.2568Z"
                                fill="#495340" />
                        </svg>
                    </button>

                    <div class="sessions-viewport" ref="viewport">
                        <div class="sessions-track" ref="track"
                            :style="{ transform: `translateX(${trackX}px)`, justifyContent: totalActiveSession <= 3 ? 'center' : '' }">
                            <button v-show="isActiveSession.vocabulary" class="session-box"
                                @click="setActiveSession('vocabulary')"
                                :class="{ active: activeSession === 'vocabulary', nodata: vocabStatus === 'no_data_report' }">
                                <div class="session-title">{{ $t('vocabulary_session') }}</div>
                                <div :class="getColor(vocabStatus)">{{ $t(vocabStatus) }}</div>
                            </button>

                            <button v-show="isActiveSession.lecture" class="session-box"
                                @click="setActiveSession('lecture')"
                                :class="{ active: activeSession === 'lecture', nodata: presentStatus === 'no_data_report' }">
                                <div class="session-title">{{ $t('presentation_session') }}</div>
                                <div :class="getColor(presentStatus)">{{ $t(presentStatus) }}</div>
                            </button>

                            <button v-show="isActiveSession.practice1" class="session-box"
                                @click="setActiveSession('practice1')"
                                :class="{ active: activeSession === 'practice1', nodata: practice1Status === 'no_data_report' }">
                                <div class="session-title">{{ $t('practice_session', { order: 1 }) }}</div>
                                <div :class="getColor(practice1Status)">{{ $t(practice1Status) }}</div>
                            </button>

                            <button v-show="isActiveSession.practice2" class="session-box"
                                @click="setActiveSession('practice2')"
                                :class="{ active: activeSession === 'practice2', nodata: practice2Status === 'no_data_report' }">
                                <div class="session-title">{{ $t('practice_session', { order: 2 }) }}</div>
                                <div :class="getColor(practice2Status)">{{ $t(practice2Status) }}</div>
                            </button>

                            <button v-show="isActiveSession.quiz" class="session-box" @click="setActiveSession('quiz')"
                                :class="{ active: activeSession === 'quiz', nodata: quizStatus === 'no_data_report' }">
                                <div class="session-title">{{ $t('quiz_session') }}</div>
                                <div :class="getColorQuiz(quizStatus)">{{ $t(quizStatus) }}</div>
                            </button>

                            <button v-show="isActiveSession.summary" class="session-box"
                                @click="setActiveSession('summary')"
                                :class="{ active: activeSession === 'summary', nodata: summaryStatus === 'no_data_report' }">
                                <div class="session-title">{{ $t('summary_session') }}</div>
                                <div :class="getColor(summaryStatus)">{{ $t(summaryStatus) }}</div>
                            </button>
                        </div>
                    </div>

                    <button class="sessions-nav ghost right" @click="slide(1)" :disabled="!canScrollRight"
                        aria-label="Scroll right">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13 2.27299e-06C10.4288 1.82344e-06 7.91543 0.762438 5.77759 2.1909C3.63975 3.61935 1.97351 5.64968 0.989571 8.02512C0.00563088 10.4006 -0.251813 13.0144 0.249795 15.5362C0.751402 18.0579 1.98953 20.3743 3.80761 22.1924C5.6257 24.0105 7.94207 25.2486 10.4638 25.7502C12.9856 26.2518 15.5994 25.9944 17.9749 25.0104C20.3503 24.0265 22.3806 22.3603 23.8091 20.2224C25.2376 18.0846 26 15.5712 26 13C25.996 9.55341 24.6251 6.24913 22.188 3.81202C19.7509 1.37491 16.4466 0.00398639 13 2.27299e-06ZM17.1689 13.7432L12.1689 18.2432C12.0714 18.3311 11.9574 18.3989 11.8336 18.4428C11.7098 18.4867 11.5786 18.5057 11.4474 18.4989C11.3162 18.492 11.1877 18.4594 11.0691 18.4028C10.9506 18.3463 10.8443 18.2669 10.7565 18.1693C10.6686 18.0717 10.6008 17.9577 10.557 17.8338C10.5132 17.71 10.4942 17.5788 10.5011 17.4476C10.5081 17.3164 10.5408 17.1879 10.5974 17.0694C10.654 16.9509 10.7334 16.8447 10.8311 16.7568L15.0049 13L10.8311 9.24317C10.6341 9.06571 10.5157 8.81731 10.5018 8.55257C10.488 8.28782 10.5798 8.02842 10.7572 7.83138C10.9346 7.63435 11.1829 7.51581 11.4476 7.50183C11.7124 7.48785 11.9718 7.57958 12.1689 7.75684L17.1689 12.2568C17.2731 12.3506 17.3565 12.4652 17.4135 12.5932C17.4705 12.7213 17.5 12.8598 17.5 13C17.5 13.1402 17.4705 13.2788 17.4135 13.4068C17.3565 13.5348 17.2731 13.6494 17.1689 13.7432Z"
                                fill="#495340" />
                        </svg>
                    </button>
                </div>

                <div>
                    <VocabularySessionPrimary v-if="activeSession === 'vocabulary' && isPrimarySchool && !loading" :vocabData="vocabData"
                        :isActive="isActiveSession.vocabulary" :key="`${reportIndex}-${reRender}`" />
                    <VocabularySession v-if="activeSession === 'vocabulary' && !isPrimarySchool && !loading" :vocabData="vocabData"
                        :isActive="isActiveSession.vocabulary" :key="`${reportIndex}-${reRender}`" />
                    <PresentationSession v-if="activeSession === 'lecture' && !loading" :presentData="presentData"
                        :isActive="isActiveSession.lecture" :key="`${reportIndex}-${reRender}`" />
                    <PracticeSession v-if="activeSession === 'practice1' && !loading" :practiceData="practice1Data"
                        :isActive="isActiveSession.practice1" :key="`practice1-${reportIndex}-${reRender}`" />
                    <PracticeSession v-if="activeSession === 'practice2' && !loading" :practiceData="practice2Data"
                        :isActive="isActiveSession.practice2" :key="`practice2-${reportIndex}-${reRender}`" />
                    <QuizSession v-if="activeSession === 'quiz' && !loading" :quizData="quizData"
                        :isActive="isActiveSession.quiz" :key="`${reportIndex}-${reRender}`" />
                    <SummarySession v-if="activeSession === 'summary' && !loading"
                        :key="`${reportIndex}-${reRender}`" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import VocabularySession from './iclassReport/VocabularySession.vue';
import VocabularySessionPrimary from './iclassReport/VocabularySessionPrimary.vue';
import PresentationSession from './iclassReport/PresentationSession.vue';
import PracticeSession from './iclassReport/PracticeSession.vue';
import QuizSession from './iclassReport/QuizSession.vue';
import SummarySession from './iclassReport/SummarySession.vue';

import { mapGetters } from 'vuex';
import { getLanguage, soundClick } from '../../utils/utils';

export default {
    name: 'ParentIclassReport',
    props: {
        reportList: {
            type: Array,
            required: true,
        },
        isPrimarySchool: {
            type: Boolean,
            required: true,
        }
    },
    components: {
        VocabularySession,
        VocabularySessionPrimary,
        PresentationSession,
        PracticeSession,
        QuizSession,
        SummarySession
    },
    data() {
        const lang = getLanguage();
        return {
            lang,
            currentDateOnCalendar: '',
            activeDates: [],
            activeSession: null,
            currentDate: 0, // timestamp
            reportDateSplit: {}, // key: timestamp, value: array of report
            iclassData: {},
            iclassDataOrder: [],
            isActiveSession: {},
            showReport: true,
            totalActiveSession: 0,
            practiceOrder: [],
            reportIndex: null,
            loading: true,
            trackX: 0,
            step: 269,
            minX: 0,
            maxNegX: 0,
            canScrollLeft: false,
            canScrollRight: false,
            reRender: 0,
            CARD_WIDTH: 253,
            GAP: 14,
            step: 267,
        };
    },
    methods: {
        measureCarousel() {
            const vp = this.$refs.viewport;
            const tr = this.$refs.track;
            if (!vp || !tr) return;

            this.step = this.CARD_WIDTH + this.GAP;

            const vpStyles = getComputedStyle(vp);
            const padL = parseFloat(vpStyles.paddingLeft) || 0;
            const padR = parseFloat(vpStyles.paddingRight) || 0;
            const innerW = vp.clientWidth - padL - padR;

            const trackW = tr.scrollWidth;
            const overflow = Math.max(0, trackW - innerW);
            this.maxNegX = -overflow;

            this.trackX = Math.min(0, Math.max(this.trackX, this.maxNegX));
            this.updateNavState();
        },

        updateNavState() {
            const near = 2;
            this.canScrollLeft = this.trackX < -near;
            this.canScrollRight = this.trackX > this.maxNegX + near;
        },

        slide(dir) {
            const next = this.trackX - dir * this.step;
            let clamped = Math.min(0, Math.max(next, this.maxNegX));

            if (dir > 0 && clamped - this.maxNegX < this.step / 2) clamped = this.maxNegX;

            this.trackX = Math.round(clamped);
            this.$nextTick(this.updateNavState);
        },

        scrollActiveIntoView() {
            const vp = this.$refs.viewport;
            const tr = this.$refs.track;
            if (!vp || !tr) return;

            const active = tr.querySelector('.session-box.active');
            if (!active) return;

            const vpRect = vp.getBoundingClientRect();
            const acRect = active.getBoundingClientRect();

            const delta = (acRect.left + acRect.right) / 2 - (vpRect.left + vpRect.right) / 2;
            let nextX = this.trackX - delta;
            nextX = Math.round(nextX);
            this.trackX = Math.min(0, Math.max(nextX, this.maxNegX));
            this.$nextTick(this.updateNavState);
        },
        getSoundClick() {
            soundClick();
        },
        prevReport(e) {
            this.reportIndex--;
            e.preventDefault();
        },
        nextReport(e) {
            this.reportIndex++;
            e.preventDefault();
        },
        getCookie(key) {
            const cookies = document.cookie
                .split(';')
                .map(cookie => cookie.split('='))
                .reduce((accumulator, [key, value]) =>
                    ({ ...accumulator, [key.trim()]: decodeURIComponent(value) }), {});
            return cookies[key];
        },
        async getIclass(params, url) {
            this.$store.commit("setLoading", true);
            this.loading = true;
            const token = this.getCookie('_wid');
            const res = await axios.get(process.env.VUE_APP_API_ICLASS + url,
                {
                    params,
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "OPTIONS",
                        "Access-Control-Allow-Headers": "Content-Type, Authorization",
                        "Access-Control-Allow-Credentials": "true",
                        "Cache-Control": "no-cache, no-store, must-revalidate",
                        "Pragma": "no-cache",
                        "Expires": "0",
                        "X-System": "ipro2"
                    }
                }
            )
            this.$store.commit("setLoading", false);
            this.loading = false;
            return res;
        },
        getColor(status) {
            switch (status) {
                case 'outstanding':
                    return 'status4';
                case 'well_done':
                    return 'status3';
                case 'need_more_effort':
                    return 'status1';
                case 'no_data_report':
                    return 'status0';
                case 'voice_not_recognized':
                    return 'status1';
                default:
                    return '';
            }
        },
        getColorQuiz(status) {
            switch (status) {
                case 'very_good':
                    return 'status4';
                case 'good':
                    return 'status3';
                case 'achieved':
                    return 'status2';
                case 'not_achieved':
                    return 'status1';
                case 'no_data_report':
                    return 'status0';
                default:
                    return '';
            }
        },
        setActiveSession(session) {
            this.activeSession = session;
            this.$nextTick(() => {
                this.scrollActiveIntoView();
            });
        },
        parseScore(value) {
            if (!value || value === "-") return 0;
            const num = parseFloat(value);
            return isNaN(num) ? 0 : num;
        },
        vocabGetHighestScore(items) {
            if (!items || !items.length) return 0;
            let highestScore = 0;
            for (const item of items) {
                const score = this.parseScore(item);
                if (score > highestScore) {
                    highestScore = score;
                }
            }
            return highestScore;
        },
        showCalendar() {
            $("#calendar").datepicker("show");
        }
    },
    watch: {
        async reportIndex(newIndex) {
            if (newIndex === null) {
                this.reportIndex = 0;
                return;
            }
            this.loading = true;
            const params = {

            };
            try {
                const response = await this.getIclass(params, '/report/iclass/' + this.reportDateSplit[this.currentDate][newIndex].id);
                this.iclassData = response.data.results;
                this.iclassDataOrder = this.iclassData.sectionConfig ? JSON.parse(this.iclassData.sectionConfig) : [];
                this.practiceOrder = [];
                this.isActiveSession = {};
                this.totalActiveSession = 0;
                for (const item of this.iclassDataOrder) {
                    if (this.activeSession === null && item.is_active === 1) {
                        this.activeSession = item.section_code;
                    }
                    if (item.section_code === 'practice') {
                        this.practiceOrder.push(item.course_item_id);
                        if (this.practiceOrder.length === 1) {
                            this.isActiveSession['practice1'] = (item.is_active === 1);
                        }
                        else this.isActiveSession['practice2'] = (item.is_active === 1);
                        this.totalActiveSession += item.is_active;
                    }
                    else {
                        this.isActiveSession[item.section_code] = (item.is_active === 1);
                        this.totalActiveSession += item.is_active;
                    }
                }
                this.reRender = 1 - this.reRender;
                this.$nextTick(() => {
                    this.measureCarousel();
                    this.scrollActiveIntoView();
                });
            } catch (error) {
                console.error('Error fetching:', error);
            } finally {
                this.loading = false;
            }
        },
        isActiveSession: {
            deep: true,
            handler() {
                this.$nextTick(this.measureCarousel);
            }
        }
    },
    mounted() {
        if (this.lang == 'vi') {
            $.datepicker.setDefaults($.datepicker.regional['vi']);
        } else {
            $.datepicker.setDefaults($.datepicker.regional['']);
        }
        if (!this.reportList || this.reportList.length === 0) {
            this.showReport = false;
            return;
        }

        this.reportIndex = 0;
        this.currentDate = this.reportList[this.reportList.length - 1].start_date;

        for (const item of this.reportList) {
            if (!this.reportDateSplit[item.start_date]) {
                this.reportDateSplit[item.start_date] = [];
                this.activeDates.push(moment.unix(item.start_date).format("DD/MM/YYYY"));
            }
            this.reportDateSplit[item.start_date].push(item);
        }
        for (const key in this.reportDateSplit) {
            this.reportDateSplit[key].sort((a, b) => a.start_time - b.start_time);
        }
        $("#calendar").datepicker({
            dateFormat: 'dd/mm/yy',
            changeMonth: true,
            changeYear: true,
            showOtherMonths: true,
            selectOtherMonths: false,
            yearRange: '1900:+0',
            maxDate: new Date(),
            defaultDate: new Date(),
            beforeShowDay: (date) => {
                const d = moment(date).format("DD/MM/YYYY");
                const today = moment().format("DD/MM/YYYY");
                let getClass = "";
                if (d === today) {
                    getClass = "ui-datepicker-today-disabled";
                }
                if (this.activeDates.includes(d)) {
                    if (d === today) {
                        return [true, "ui-datepicker-today-active", ""];
                    }
                    return [true, "", ""];
                }
                return [false, getClass, ""];
            },
            onSelect: (dateText) => {
                this.currentDateOnCalendar = dateText;
                this.currentDate = moment(dateText, "DD/MM/YYYY").unix();
                this.reportIndex = null;
            },
        });
        this.currentDateOnCalendar = this.activeDates[this.activeDates.length - 1];
        this.$nextTick(() => {
            this.measureCarousel();
            this.scrollActiveIntoView();
        });
        window.addEventListener('resize', this.measureCarousel);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.measureCarousel);
    },
    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        }),
        vocabData() {
            return this.iclassData?.vocab ?? [];
        },
        presentData() {
            return this.iclassData?.lecture ?? [];
        },
        practice1Data() {
            if (!this.iclassData?.practices?.[0] || this.practiceOrder.length < 1) return {};
            for (const item of this.iclassData.practices) {
                if (item.course_item_id == this.practiceOrder[0]) {
                    return item;
                }
            }
            return {};
        },
        practice2Data() {
            if (!this.iclassData?.practices?.[0] || this.practiceOrder.length < 2) return {};
            for (const item of this.iclassData.practices) {
                if (item.course_item_id == this.practiceOrder[1]) {
                    return item;
                }
            }
            return {};
        },
        quizData() {
            return this.iclassData?.quiz ?? [];
        },
        reportDateFormat() {
            if (this.reportIndex == null || !this.reportDateSplit[this.currentDate][this.reportIndex]) {
                return '';
            }
            const start_date = new Date(this.reportDateSplit[this.currentDate][this.reportIndex].start_date * 1000);
            const start_time = moment.utc(this.reportDateSplit[this.currentDate][this.reportIndex].start_time * 1000).format('HH:mm');
            const end_time = moment.utc(this.reportDateSplit[this.currentDate][this.reportIndex].end_time * 1000).format('HH:mm');

            const day = start_date.toLocaleDateString('vi-VN', {
                timeZone: 'Asia/Ho_Chi_Minh',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });

            return `${day}` + ' ' + start_time + ' - ' + end_time;
        },
        className() {
            if (this.reportIndex == null || !this.reportDateSplit[this.currentDate][this.reportIndex]) {
                return '';
            }
            return this.reportDateSplit[this.currentDate][this.reportIndex].name;
        },
        hasOneReport() {
            if (this.reportDateSplit[this.currentDate] && this.reportDateSplit[this.currentDate].length <= 1) {
                return true;
            }
            return false;
        },
        vocabStatus() {
            if (!this.vocabData || !this.vocabData.length || !this.isActiveSession.vocabulary) {
                return 'no_data_report';
            }
            let sum = 0, count = 0, hasRecorded = false;
            for (const item of this.vocabData) {
                for (const item1 of item.wordVocab) {
                    count += 1;
                    sum += this.vocabGetHighestScore(item1.points);
                    if (item1.points?.length && item1.points?.length > 0) {
                        hasRecorded = true;
                    }
                }
            }
            if (!hasRecorded) {
                return 'no_data_report';
            }
            let score = count > 0 ? (sum / count) : 0;
            if (isNaN(score) || score < 10) {
                return "voice_not_recognized";
            } else if (score < 40) {
                return "need_more_effort";
            } else if (score < 80) {
                return "well_done";
            } else {
                return "outstanding";
            }
        },
        presentStatus() {
            if (!this.presentData || !this.presentData.length || !this.isActiveSession.lecture) {
                return 'no_data_report';
            }
            let totalCorrect = 0, totalQuestion = this.presentData.length;
            for (const item of this.presentData) {
                let sum = 0;
                if (item.answers && item.answers.length) {
                    for (const answer of item.answers) {
                        sum += answer.point;
                    }
                }
                if (sum == item.point) {
                    sum = Math.round(sum * 2) / 2;
                    totalCorrect += 1;
                }
            }
            let score = totalCorrect / totalQuestion;
            if (isNaN(score) || score < 0.4) {
                return "need_more_effort";
            } else if (score < 0.8) {
                return "well_done";
            } else {
                return "outstanding";
            }
        },
        practice1Status() {
            if (!this.practice1Data || !this.isActiveSession.practice1) {
                return "no_data_report";
            }
            if (!this.practice1Data.questions || !this.practice1Data.questions.length) {
                return "no_data_report";
            }
            let sum = 0;
            for (const item of this.practice1Data.questions) {
                sum += item.is_correct ? 1 : 0;
            }
            let score = sum / this.practice1Data.questions.length;
            if (isNaN(score) || score < 0.4) {
                return "need_more_effort";
            } else if (score < 0.8) {
                return "well_done";
            } else {
                return "outstanding";
            }
        },
        practice2Status() {
            if (!this.practice2Data || !this.isActiveSession.practice2) {
                return "no_data_report";
            }
            if (!this.practice2Data.questions || !this.practice2Data.questions.length) {
                return "no_data_report";
            }
            let sum = 0;
            for (const item of this.practice2Data.questions) {
                sum += item.is_correct ? 1 : 0;
            }
            let score = sum / this.practice2Data.questions.length;
            if (isNaN(score) || score < 0.4) {
                return "need_more_effort";
            } else if (score < 0.8) {
                return "well_done";
            } else {
                return "outstanding";
            }
        },
        quizStatus() {
            if (!this.quizData || !this.quizData.length || !this.isActiveSession.quiz) {
                return 'no_data_report';
            }
            let maxPoint = 0, totalScore = 0;
            for (const item of this.quizData) {
                maxPoint += item.point;
                let sum = 0, correct = 0;
                if (item.answers && item.answers.length) {
                    for (const answer of item.answers) {
                        sum += answer.point;
                        correct += answer.isCorrect;
                    }
                }
                if (correct == item.totalCorrectAnswer) {
                    sum = Math.round(sum * 2) / 2;
                    totalScore += sum;
                }
            }
            let score = totalScore / maxPoint;
            if (score < 0.4) {
                return "not_achieved";
            } else if (score < 0.6) {
                return "achieved";
            } else if (score < 0.8) {
                return "good";
            } else {
                return "very_good";
            }
        },
        summaryStatus() {
            return 'no_data_report';
        },
    },
};
</script>

<style scoped>
.btn-left,
.btn-right {
    background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
    color: #fff;
    border: none;
    border-radius: 999px;
    cursor: pointer;
    font-size: 14px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    box-shadow: 0 6px 12px rgba(10, 160, 255, 0.25);
    margin: 20px 30px;
}

.btn-left { min-width: 149px; }
.btn-right { min-width: 124px; }

.btn-left:hover,
.btn-right:hover {
    background: linear-gradient(180deg, #33B4FF 0%, #0095F0 100%);
}

.btn-left[disabled],
.btn-right[disabled] {
    opacity: 0.5;
}

.btn-date {
    color: #3263C0;
    text-align: center;
    font-size: 20px;
    background: none;
    border: none;
    cursor: pointer;
    display: block;
    margin: 0 auto;
    font-weight: bold;
    text-decoration: underline;
    padding: 6px;
}

.card-header {
    background: #FFE39B;
    border-radius: 4px 4px 0px 0px;
    display: flex;
    align-items: center;
    padding: 20px 30px;
    border: none;
    position: relative;
    color: #000000;
}

.card-title {
    margin: 0;
    font-size: 20px;
    font-weight: bold;
}

.session-container {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}

.session-box {
    border: 1px solid #CCC;
    border-radius: 8px;
    padding: 14px 18px;
    width: 253px;
    height: 80px;
    top: 147px;
    display: flex;
    gap: 4px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;
    outline: none;
    font-family: inherit;
    font-size: 18px;
    flex: 0 0 253px;
}

.session-box:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.session-box.active {
    background-color: #ACE4FB !important;
    border: 3px solid #1890ff;
    padding: 14px;
}

.session-box.nodata {
    background-color: #D5D5D5;
}

.sessions-wrapper.no-scroll {
    position: relative;
    display: flex;
    align-items: center;
}

.sessions-viewport {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    padding: 8px 30px;
    position: relative;
    z-index: 1;
}

.sessions-track {
    display: flex;
    gap: 14px;
    will-change: transform;
    transition: transform .35s ease;
}

.sessions-nav {
    all: unset;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 36px;
    height: 36px;
    display: grid;
    place-items: center;
    border-radius: 999px;
    background: #EEF3FF;
    color: #93A4C0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .08);
    cursor: pointer;
    z-index: 2;
}

.sessions-nav:hover {
    background: #E2ECFF;
    color: #2F66C9;
}

.sessions-nav[disabled] {
    display: none;
}

.sessions-nav.left {
    left: 8px;
}

.sessions-nav.right {
    right: 8px;
}

.sessions-nav svg {
    display: block;
}

.session-title {
    color: #333;
    margin-bottom: 8px;
    font-size: 18px;
    text-align: center;
    font-weight: bold;
}

.status0 {
    color: #000000;
    font-weight: bold;
}

.status1 {
    color: #FF0000;
    font-weight: bold;
}

.status2 {
    color: #7158C2;
    font-weight: bold;
}

.status3 {
    color: #FFA800;
    font-weight: bold;
}

.status4 {
    color: #28A745;
    font-weight: bold;
}

.form-control {
    width: 100%;
    padding: 8px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
}

.datepicker {
    cursor: pointer;
}

.hidden {
    display: none;
}
</style>

<style>
.ui-datepicker-current-day .ui-state-active {
    background: #cde0eb !important;
}

.ui-datepicker .ui-datepicker-calendar td.ui-datepicker-today-disabled>span {
    color: #25a8ff !important;
}

.ui-datepicker .ui-datepicker-calendar td.ui-datepicker-today-active a {
    color: #25a8ff !important;
}
</style>